import { IUserRole } from 'src/modules/common/user/types';
export const getOfflineAuthor = () => {
    return {
        id: 'offline-author',
        details: {
            firstName: 'Offline',
            lastName: 'Author',
            avatarURL: '',
            userName: 'Offline Author',
            email: 'offline-author@marinesamraj.com',
        },
        reputation: {
            score: 0,
            badgesInfo: {
                summary: {
                    gold: 0,
                    silver: 0,
                    bronze: 0,
                },
                badges: []
            }
        },
        roles: [IUserRole.USER],
    };
};
